import { render, staticRenderFns } from "./Cuestionarios.vue?vue&type=template&id=b226c2ce"
import script from "./Cuestionarios.vue?vue&type=script&lang=js"
export * from "./Cuestionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports